import type { CSSProperties, ElementType, HTMLAttributes, ReactNode } from 'react';

export type CardProps = Omit<HTMLAttributes<HTMLElement>, 'className'> & {
  as?: ElementType;
  /**
   * Variação do pacote: `panel` (padding de painel), `recent` (painel com tabela), `none` (sem padding próprio).
   * Outras classes do pacote (ex.: `stat`, `filters`, `tx-table`, `ic-card`) vão em `className`.
   */
  padding?: 'panel' | 'recent' | 'none';
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
};

/** Cartão branco do pacote (`.card`). */
export function Card({ as: As = 'div', padding = 'none', className, children, ...rest }: CardProps) {
  const cls = ['card', padding === 'none' ? '' : padding, className].filter(Boolean).join(' ');
  return <As className={cls} {...rest}>{children}</As>;
}
